import { useModuleConfig } from '@/utils/hooks/useModuleConfig'
import { Module, ModuleOptionsValue } from '../../companies'

export interface SalaryModuleConfiguration {
  driverApprove: boolean
  managerApprove: boolean
  useCalendarForOvertime: boolean
  usePlannerForOvertime: boolean
  onlyIncludeApprovedHours: boolean
}

export const useSalaryModuleConfiguration = () => {
  const { getModuleOptionStatus } = useModuleConfig(Module.SALARY)

  const usePlannerForOvertime = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_USE_PLANNED_WORK_FOR_OVERTIME
  )
  const driverApproveEnabled = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_USER_APPROVE_HOURS
  )
  const managerApproveEnabled = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_LEADER_APPROVE_HOURS
  )
  const onlyIncludeApprovedHours = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_ONLY_INCLUDE_APPROVED_HOURS
  )

  const canTransferWorkToAbsence = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_ALLOW_TRANSFER_OF_HOURS_TO_ABSENCES
  )

  return {
    driverApprove: driverApproveEnabled,
    managerApprove: managerApproveEnabled,
    canTransferWorkToAbsence,
    useCalendarForOvertime: usePlannerForOvertime,
    onlyIncludeApprovedHours:
      onlyIncludeApprovedHours &&
      (driverApproveEnabled || managerApproveEnabled),
    usePlannerForOvertime: usePlannerForOvertime,
  }
}
